











import { Component, Vue } from 'vue-property-decorator';
import CapacitacionesBase from '@/pantallas/SucursalVirtual/Capacitaciones/CapacitacionesBase.vue';

@Component({
  components: { CapacitacionesBase },
})
export default class CapacitacionPantalla extends Vue {}
